import React, { useState } from "react";
import { ConnectedButtonIcon } from "../../../assets/icons/connected-button-icon";
import { LinkIconWhite } from "../../../assets/icons/link-icon-white";
import { LinkIconBlack } from "../../../assets/icons/link-icon-black";
import TrickCircle from "../../../assets/icons/trick-circle";

const FullWidthCard = ({ imageSrc, title, description, buttonText, classes, cardType = 'flex', onClick, isfbDisconnect, fb, connected, isMicroSoftIntegration, isFbIntegration }) => {
    const [hoverFb, setHoverFb] = useState(false)
    const [hoverMicrosoft, setHoverMicrosoft] = useState(false)
    return (
        <div className={` items-center p-[24px] border rounded-lg bg-white w-full ${classes ? classes : ""} ${cardType != 'flex' ? '' : 'flex'}`}>
            <div className="flex justify-between">
                <img src={imageSrc} alt={title} className={`w-12 h-12 mr-4  ${cardType != 'flex' ? 'mb-6' : ''}`} /> {connected ? <ConnectedButtonIcon /> : ""}
            </div>

            <div className={`flex-1 ${cardType != 'flex' ? 'mb-4' : ''}`}>
                <h3 className="text-lg font-semibold text-[20px] font-mont mb-4 text-[#1B2A3D]">{title}</h3>
                <div className="text-[#373737] text-[16px] font-[400] font-mont three-line h-[70px]">
                    {fb ? (isFbIntegration.metaPageName?<>
                        <div className="text-[16px] font-medium flex mb-[5px]"><span className="mr-[10px]"><TrickCircle /></span><span className="text-black">{isFbIntegration.metaPageName}</span></div>
                        <div className="flex "><span className="w-[24px] mr-[10px]"></span><span>{isFbIntegration.metaAdaccountID}</span></div>
                    </>:description) : description}
                </div>
            </div>
            {fb ? isfbDisconnect ? <button className="px-5 py-1 rounded-md border primary_btn transition-all duration-500 red_btn h-[42px] text-[14px] font-mont font-[500]" onClick={onClick}>     {buttonText}</button> :
                <button
                    onClick={onClick}
                    onMouseEnter={() => setHoverFb(true)}
                    onMouseLeave={() => setHoverFb(false)}
                    className="flex items-center  btn-primary-base-bar primary_btn text-white py-2 px-5 rounded-[5px] hover:bg-white border hover:border-[#245CEA] hover:text-[#1A1A1B] transition duration-300 h-[42px] text-[14px] font-mont font-[500]"
                >
                    {cardType == 'flex' ? hoverFb ? <LinkIconBlack /> : <LinkIconWhite /> : ''}
                    {buttonText}
                </button> : isMicroSoftIntegration ? <button className="px-5 py-1 rounded-md border primary_btn transition-all duration-500 red_btn h-[42px] text-[14px] font-mont font-[500]" onClick={onClick}>     {buttonText}</button> : <button
                    onClick={onClick}
                    onMouseEnter={() => setHoverMicrosoft(true)}
                    onMouseLeave={() => setHoverMicrosoft(false)}
                    className="flex items-center bg-[#245CEA] text-white py-2 px-5 rounded-[5px] hover:bg-white border hover:border-[#245CEA] hover:text-[#1A1A1B] transition duration-300 h-[42px] text-[14px] font-mont font-[500]"
                >
                    {cardType == 'flex' ? hoverMicrosoft ? <LinkIconBlack /> : <LinkIconWhite /> : ''}
                    {buttonText}
                </button>}
        </div>
    );
};

export default FullWidthCard;
